// src/ui/Timezones.js

export const TIMEZONES_BY_REGION = {
  Africa: [
    "Africa/Cairo",
    "Africa/Johannesburg",
    "Africa/Lagos",
    "Africa/Nairobi",
    "Africa/Casablanca",
  ],

  Americas: [
    // United States
    "America/Los_Angeles",
    "America/Denver",
    "America/Chicago",
    "America/New_York",

    // Canada
    "America/Vancouver",
    "America/Toronto",

    // Latin America
    "America/Mexico_City",
    "America/Sao_Paulo",
    "America/Bogota",
    "America/Buenos_Aires",
    "America/Santiago",
  ],

  Asia: [
    "Asia/Tokyo",
    "Asia/Shanghai",
    "Asia/Hong_Kong",
    "Asia/Singapore",
    "Asia/Seoul",
    "Asia/Taipei",
    "Asia/Bangkok",
    "Asia/Kolkata",
    "Asia/Dubai",
  ],

  Europe: [
    "Europe/London",
    "Europe/Dublin",
    "Europe/Paris",
    "Europe/Berlin",
    "Europe/Amsterdam",
    "Europe/Zurich",
    "Europe/Rome",
    "Europe/Madrid",
    "Europe/Stockholm",
    "Europe/Prague",
  ],

  Pacific: [
    "Australia/Sydney",
    "Australia/Melbourne",
    "Australia/Brisbane",
    "Australia/Perth",
    "Pacific/Auckland",
  ],
};

// Optional but recommended
export function formatTimezoneLabel(tz) {
  try {
    const parts = Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      timeZoneName: "short",
    }).formatToParts(new Date());

    const offset = parts.find(p => p.type === "timeZoneName")?.value;
    const city = tz.split("/").pop().replace(/_/g, " ");

    return offset ? `${city} (${offset})` : city;
  } catch {
    return tz;
  }
}
